import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Flight, Segment } from 'src/app/core/models/itinerary.model';
import { SegmentType } from 'src/app/core/enums/enums';
import { TpTravelService } from 'src/app/core/api/tptravel.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { Observable } from 'rxjs';
import { IClientSettings } from 'src/app/core/models/agency-settings.model';
import { IFarebasisSegment } from 'src/app/core/models/models';

@Component({
  selector: 'app-segment-header',
  templateUrl: './segment-header.component.html',
  styleUrls: ['./segment-header.component.scss']
})
export class SegmentHeaderComponent implements OnChanges, OnInit {
  @Input() segment: Segment;
  @Input() index: number;
  @Input() isMultidestiny = true;
  @Input() baggageAllowance: number;
  @Input() showBaggage = true;
  @Input() isAirline: boolean;
  @Input() flights: Flight[];
  @Input() isInvoluntary: boolean;
  @Input() showSeatsAvailability = false;

  public settings$: Observable<IClientSettings>;

  segmentType = SegmentType;
  filteredIconsUrl = [];
  fareBasisSegment: IFarebasisSegment = {
    hasFarebasisCodes: false,
    farebasisCodes: []
  };

  get seatsNotAvailable(): boolean {
    return this.flights?.every((flight) =>
      flight?.availableClasses?.every((availableClass) => availableClass.seats === 0)
    );
  }

  get seatsAvailable() {
    return this.flights?.every((flight) => flight?.seatsAvailable);
  }

  constructor(private tpTravelService: TpTravelService, private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.settings$ = this.settingsService.getClientSettings();
    this.extractFareBasisCodes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.segment?.currentValue) {
      this.fetchMarketingCarrierIcons();
    }
  }

  extractFareBasisCodes() {
    this.segment.flights.forEach((flight) => {
      if (flight?.fareBasis) {
        this.fareBasisSegment.hasFarebasisCodes = true;
        this.fareBasisSegment.farebasisCodes.push(flight.fareBasis);
      }
    });
  }

  fetchMarketingCarrierIcons() {
    this.segment.marketingCarriers.forEach((carrier) => {
      const iconUrl = this.tpTravelService.getIconAirline(carrier.code);
      this.filteredIconsUrl.push(iconUrl);
    });
  }

  checkAvailableClassesIsVoid() {
    this.flights.map((flight) => {
      if (flight.availableClasses.length === 0) {
        return true;
      }
    });
  }
}
